//#region components/datepicker/datepicker_constants.js
var e = 0, t = "long";
//#endregion
export { t as INTL_MONTH_FORMAT, e as WEEK_START };

//# sourceMappingURL=datepicker-constants.js.map